import { BusinessHolderForm } from "@/modules/dashboard/cards/components/holder/BusinessHolderForm";
import type { CreateBusinessIdentityRequest } from "@/modules/dashboard/cards/types/identity-form.types";
import { ColocaButton } from "@/shared/components/buttons/ColocaButton";
import useTranslations from "@/shared/lang/useTranslations";

import { VerificationService } from "../services/verificationService";
import type { CreateVerificationResponse } from "../types/verification-api.types";

const KYB_FORM_ID = "verification-kyb-company-form";

export interface KybCompanyStepProps {
  onCreated: (response: CreateVerificationResponse) => void;
}

/**
 * KYB "Empresa" step (marco A). Reuses the existing `BusinessHolderForm` — which already builds the full
 * nested `CreateIdentityDto` (company + representative + both addresses, with country-dependent document
 * types) — and redirects its submit to `verification/business` with `is_organization_identity: true` so the
 * org's corporate identity gets linked. The created identity (id + token) flows back via `onCreated` to drive
 * the capture step.
 */
export function KybCompanyStep({ onCreated }: KybCompanyStepProps) {
  const { t } = useTranslations("verification");

  return (
    <div className="space-y-6">
      <div className="space-y-1">
        <h2 className="text-xl font-semibold text-foreground">{t("company_title")}</h2>
        <p className="text-sm text-muted-foreground">{t("company_dedupe_note")}</p>
      </div>

      <BusinessHolderForm
        formId={KYB_FORM_ID}
        showSuccessToast={false}
        submit={(payload: CreateBusinessIdentityRequest) =>
          VerificationService.createBusiness({ ...payload, is_organization_identity: true })
        }
        onSuccess={(response) => {
          if (response) onCreated(response);
        }}
      />

      <ColocaButton type="submit" form={KYB_FORM_ID} variant="primary" className="w-full">
        {t("button_continue")}
      </ColocaButton>
    </div>
  );
}
